import React, { Fragment, useState, useEffect } from 'react';
import './NewMenuv2.scss';
import { redirectWithCookies } from '../../utils/Utm';

const NewMenuV2 = () => {
  const [activeMenu, setActiveMenu] = useState(null);

  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [mobileSubMenuIndex, setMobileSubMenuIndex] = useState(null);

  const menuData = [
    {
      label: 'Soluções',
      items: [
        {
          title: 'Força de vendas',
          description: '+25 indicadores e +30 relatórios para gerenciar sua equipe',
          icon: '/images/site/icons/graph.svg',
          link: '/forca-vendas/'
        },
        {
          title: 'E-commerce B2B',
          description: 'Venda 24h por dia com a loja online de empresas para empresas',
          icon: '/images/site/icons/cart.svg',
          link: '/e-commerce-b2b'
        },
        {
          type: 'separator',
          label: 'Outras soluções'
        },
        {
          title: 'Pedidos com IA',
          description: 'Transforme áudio, texto, imagem ou planilha em pedidos com a IA',
          icon: '/images/site/recursos/sparkle.svg',
          link: '/recursos/sistema-pedidos-com-ia',
          badge: (<div className='new-badge'>NOVO</div>)
        },
        {
          title: 'Mercos Pay',
          description: 'Receba pagamentos por pix, boleto e cartões de crédito',
          icon: '/images/site/icons/card.svg',
          link: '/mercos-pay'
        },
        {
          title: 'Videochamada',
          description: 'Venda por vídeo com experiência de visita presencial dentro do e-commerce B2B',
          icon: '/images/site/icons/videocall.svg',
          link: '/videochamada'
        }
      ]
    },
    {
      label: 'Segmentos',
      items: [
        {
          title: 'Indústrias',
          description: 'Automatize vendas, conecte canais e escale seu negócio com inteligência',
          icon: '/images/site/icons/industry.svg',
          link: '/sistema-para-industria/'
        },
        {
          title: 'Distribuidoras',
          description: 'Gerencie clientes e pedidos, vendas automatizadas e integração total',
          icon: '/images/site/icons/distributor.svg',
          link: '/sistema-distribuidora/'
        },
        {
          title: 'Representantes',
          description: 'Crie e gerencie políticas comerciais para cada cliente e representada',
          icon: '/images/site/icons/representatives.svg',
          link: '/sistema-representante/'
        }
      ]
    },
    {
      label: 'Planos e Preços',
      items: [
        {
          title: (
            <Fragment>
              Planos para <b>Indústrias e distribuidoras</b>
            </Fragment>
          ),
          description: '',
          icon: '/images/site/icons/industry.svg',
          link: '/planos-e-precos/industrias-e-distribuidoras/'
        },
        {
          title: (
            <Fragment>
              Planos para <br /> <b>Representantes</b>
            </Fragment>
          ),
          description: '',
          icon: '/images/site/icons/representatives.svg',
          link: '/planos-e-precos/representantes/'
        }
      ]
    },
    {
      label: 'Integrações',
      items: [
        {
          title: 'ERPs integrados',
          description: '+ 250 ERPs parceiros integrados ao Forças de vendas e E-commerce B2B',
          icon: '/images/site/icons/mapping.svg',
          link: '/integracao-erp'
        },
        {
          title: 'Seja Parceiro',
          description: 'Seja um Mpartner e leve seu negócio ao próximo nível',
          icon: '/images/site/icons/people.svg',
          link: '/parceiros'
        }
      ]
    }
  ];

  const MobileCTA = () => (
    <div className="nmv2-mobile-actions">
      <button
        className="nmv2-mobile-cta-button"
        onClick={() => redirectWithCookies('https://app.mercos.com/cadastro/')}
      >
        comece grátis
      </button>

      <div
        className="nmv2-mobile-login-link"
        onClick={() => redirectWithCookies('https://app.mercos.com/login/')}
      >
        entrar no Mercos <img src="/images/arrow-vector.svg" alt="arrow" />
      </div>
    </div>
  );

  const handleMouseEnter = (index) => setActiveMenu(index);
  const handleMouseLeave = () => setActiveMenu(null);

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
    if (mobileMenuOpen) {
      setMobileSubMenuIndex(null);
    }
  };

  const toggleMobileSubMenu = (index) => {
    setMobileSubMenuIndex(mobileSubMenuIndex === index ? null : index);
  };

  const goBackToMainMenu = () => {
    setMobileSubMenuIndex(null);
  };

  useEffect(() => {
    if (mobileMenuOpen) {
      document.body.classList.add('mobile-menu-is-open');
    } else {
      document.body.classList.remove('mobile-menu-is-open');
    }
    return () => {
      document.body.classList.remove('mobile-menu-is-open');
    };
  }, [mobileMenuOpen]);

  return (
    <nav className="newmenuv2">
      <div className="container">
        <div className='menu-logo'>
          <a href="/">
            <img
              src="/images/site/logo-mercos-colored.svg"
              alt="Mercos Logo"
              className="nmv2-logo"
            />
          </a>
        </div>

        <div className='menu-list'>
          <ul className="nmv2-menu-list">
            {menuData.map((menuItem, idx) => (
              <li
                key={idx}
                className={`nmv2-menu-item ${menuItem.className || ''}`}
                onMouseEnter={() => handleMouseEnter(idx)}
                onMouseLeave={handleMouseLeave}
              >
                <button className="nmv2-menu-button">{menuItem.label}</button>

                <div className={`nmv2-submenu ${activeMenu === idx ? 'active' : ''}`}>
                  <div className="submenu-arrow-up"></div>
                  <ul>
                    {menuItem.items.map((item, subIdx) => {
                      if (item.type === 'separator') {
                        return (
                          <li key={subIdx} className="nmv2-submenu-separator">
                            {item.label}
                          </li>
                        );
                      }
                      return (
                        <li key={subIdx} className="nmv2-submenu-item">
                          <a href={item.link}>
                            <img
                              src={item.icon}
                              alt={`${item.title} icon`}
                              className="nmv2-submenu-icon"
                            />
                            <div className="nmv2-submenu-text">
                              <div className="item-title">
                                {typeof item.title === 'string' ? (
                                  <strong>{item.title}</strong>
                                ) : (
                                  item.title
                                )}{item.badge && item.badge}
                              </div>
                              <p>{item.description}</p>
                            </div>
                          </a>
                        </li>
                      );
                    })}
                  </ul>
                </div>
              </li>
            ))}
          </ul>
        </div>

        <div className='menu-signin'>
          <button
            className="nmv2-cta-button"
            onClick={() => redirectWithCookies('https://app.mercos.com/cadastro/')}
          >
            comece grátis
          </button>

          <div
            className="nmv2-login-link"
            onClick={() => redirectWithCookies('https://app.mercos.com/login/')}
          >
            Entrar <img src="/images/arrow-vector.svg" alt="arrow" />
          </div>
        </div>

        <button
          className="nmv2-hamburger"
          onClick={toggleMobileMenu}
          aria-label="Open mobile menu"
        >
          {mobileMenuOpen ? (
            <img src="/images/site/icons/close-menu.svg" alt="Fechar" />
          ) : (
            <img src="/images/site/icons/hamburger.svg" alt="Abrir" />
          )}
        </button>

        {mobileMenuOpen && (
          <div className="nmv2-mobile-menu">
            {mobileSubMenuIndex === null ? (
              <Fragment>
                <ul className="nmv2-mobile-menu-list">
                  {menuData.map((menuItem, idx) => (
                    <li key={idx} className="nmv2-mobile-menu-item">
                      <button
                        className="nmv2-mobile-menu-button"
                        onClick={() => toggleMobileSubMenu(idx)}
                      >
                        {menuItem.label}
                        <span className="nmv2-mobile-arrow"></span>
                      </button>
                    </li>
                  ))}
                </ul>

                <MobileCTA />
              </Fragment>
            ) : (
              <Fragment>
                <div className="nmv2-mobile-submenu">
                  <div className="nmv2-mobile-submenu-header">
                    <button className="nmv2-mobile-back-button" onClick={goBackToMainMenu}>
                      <span className="nmv2-mobile-back-arrow"></span>
                      {menuData[mobileSubMenuIndex].label}
                    </button>
                  </div>

                  <ul className="nmv2-mobile-submenu-list">
                    {menuData[mobileSubMenuIndex].items.map((item, subIdx) => {
                      if (item.type === 'separator') {
                        return (
                          <li key={subIdx} className="nmv2-mobile-submenu-separator">
                            {item.label}
                          </li>
                        );
                      }
                      return (
                        <li key={subIdx} className="nmv2-mobile-submenu-item">
                          <a href={item.link}>
                            <img
                              src={item.icon}
                              alt={`${item.title} icon`}
                              className="nmv2-mobile-submenu-icon"
                            />
                            <div className="nmv2-mobile-submenu-text">
                              <div className="mobile-item-title">
                                {typeof item.title === 'string' ? (
                                  <strong>{item.title}</strong>
                                ) : (
                                  item.title
                                )}{item.badge && item.badge}
                              </div>
                              <p>{item.description}</p>
                            </div>
                          </a>
                        </li>
                      );
                    })}
                  </ul>

                  <MobileCTA />
                </div>
              </Fragment>
            )}
          </div>
        )}
      </div>
    </nav>
  );
};

export default NewMenuV2;


// WEBPACK FOOTER //
// /usr/src/site-blog/src/blocks/Menu/NewMenuv2.jsx